var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "103.65px",
    height: "87px",
    viewBox: "12.51 10.5 103.65 87",
    enableBackground: "new 12.51 10.5 103.65 87",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ata-tm-color-logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M99.51,10.5H18.954c-3.56,0-6.444,2.885-6.444,6.444v74.111c0,3.559,2.885,6.444,6.444,6.444H99.51 c3.56,0,6.444-2.886,6.444-6.444V16.944C105.954,13.385,103.069,10.5,99.51,10.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F47E14",
    d: "M100.315,84.312h-7.009c-3.665,0-5.639,1.531-5.639,4.414c0,2.885,1.885,4.358,5.775,4.358 c1.111,0.04,2.222-0.103,3.287-0.418v4.56c-0.282,0.105-0.569,0.196-0.862,0.273h3.642c0.27-0.002,0.539-0.021,0.806-0.057V84.312 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F47E14",
    d: "M99.51,10.5H18.954c-3.56,0-6.444,2.885-6.444,6.444v74.111c0,3.559,2.885,6.444,6.444,6.444h19.333 c-1.578-0.351-3.024-1.142-4.173-2.279c-1.574-1.742-2.411-4.026-2.336-6.373c0-5.332,3.851-8.522,10.295-8.522h7.958v-2.23 c0-4.028-1.99-5.712-6.662-5.712c-3.077,0-4.833,0.806-6.565,2.908l-3.77-3.568c2.667-3.143,5.438-4.262,10.553-4.262 c8.12,0,12.244,3.424,12.244,10.182V97.5h15.74c-3.504-0.33-7.201-2.594-7.201-8.177l0,0V59.236h5.824v8.562h5.792v4.406h-5.792 v16.821c0,2.344,1.176,3.584,3.407,3.584h2.417v4.89H88.57c-1.581-0.351-3.029-1.141-4.182-2.279 c-1.573-1.742-2.41-4.026-2.335-6.373c0-5.332,3.851-8.522,10.295-8.522h7.967v-2.23c0-4.028-1.99-5.712-6.654-5.712 c-3.085,0-4.833,0.806-6.573,2.908l-3.754-3.568C86,68.58,88.78,67.461,93.888,67.461c7.16,0,11.205,2.666,12.083,7.927V16.944 c0-3.559-2.886-6.444-6.444-6.444"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F47E14",
    d: "M45.602,97.5h4.406V84.312h-7.016c-3.657,0-5.59,1.531-5.59,4.414c0,2.885,1.885,4.358,5.768,4.358 c1.114,0.039,2.226-0.103,3.295-0.418v4.56C46.182,97.331,45.9,97.42,45.602,97.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F47E14",
    points: "105.938,91.587 105.938,92.15 107.646,92.15 107.646,97.5 108.282,97.5 108.282,92.15  109.989,92.15 109.989,91.587  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F47E14",
    points: "115.524,91.587 113.646,95.784 111.722,91.587 111.094,91.587 111.094,97.5 111.722,97.5  111.722,93.005 113.365,96.573 113.905,96.573 115.524,93.005 115.524,97.5 116.16,97.5 116.16,91.587  "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAta);
export default __webpack_public_path__ + "static/media/ata.3339297ddace4428cf02babd270c3afa.svg";
export { ForwardRef as ReactComponent };